import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {SaleInvoiceConfigurationModel} from '../../../api/entity/saleInvoiceConfiguration.model';
import {SaleInvoiceConfigurationConverter} from '../../../api/entity/converter/saleInvoiceConfiguration.converter';


@Injectable({providedIn: 'root'})
export class SaleInvoiceConfigurationDataService
    extends AbstractDataServiceV2<SaleInvoiceConfigurationModel, SaleInvoiceConfigurationConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: SaleInvoiceConfigurationConverter) {
        super('SaleInvoiceConfiguration', http, httpUrlGenerator, logger, config, converter);
    }
}
